<template>
  <div class="nav-container">
    <nav class="sidebar sidebar-offcanvas" id="sidebar">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="/dashboard">
            <i class="ti-home menu-icon"></i>
            <span class="menu-title">Dashboard</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/principal">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">Principal Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/customer">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">Customer Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/sat">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">SAT Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/district">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">DM Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/nationalsales">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">NSM Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/regionalsales">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">RSM Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/territory">
            <i class="icon-grid menu-icon"></i>
            <span class="menu-title">Agent Maintenance</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-toggle="collapse"
            href="#reports"
            aria-expanded="false"
            aria-controls="reports"
          >
            <i class="ti-download menu-icon"></i>
            <span class="menu-title">Reports</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="collapse" id="reports">
            <ul class="nav flex-column sub-menu ps-4">
              <li class="nav-item">
                <a class="nav-link" href="/reports/bincards">
                  BIN Card for Principal
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports/sales">
                  Sales Transaction
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports/deliverymonitoring">
                  Delivery Monitoring
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports/billcollector">
                  Detailed Aging
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports/pdccollection">
                  PDC Collection
                </a>
              </li>
              <li class="nav-item" @click="showGenerateAllReport = true">
                <a class="nav-link" href="#"> Generate All Reports </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports/logs"> Report Logs </a>
              </li>
            </ul>
          </div>
        </li>
        
        <li class="nav-item">
          <a class="nav-link" @click="redirectToReportsOverview" target="http://ors-report.oxford.ph">
            <i class="ti-settings menu-icon"></i>
              <span class="menu-title">New Reports</span>
          </a>
        </li>
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            data-toggle="collapse"
            href="#reports-overview"
            aria-expanded="false"
            aria-controls="reports-overview"
          >
            <i class="ti-download menu-icon"></i>
            <span class="menu-title">Reports Overview</span>
            <i class="menu-arrow"></i>
          </a>
          <div class="collapse" id="reports-overview">
            <ul class="nav flex-column sub-menu ps-4">
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/inventorylevel" target="reports-overview/inventorylevel">
                  Inventory Level
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/consignmentorder" target="reports-overview/consignmentorder">
                  Consignment Monitoring <br>Report
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/pendingsalesorder" target="reports-overview/pendingsalesorder">
                  Work-in-Progress
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/pendingsalesordercs" target="reports-overview/pendingsalesordercs">
                  Sales Orders For <br>Resolution Report
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/detailedagingbyprincipal" target="reports-overview/detailedagingbyprincipal">
                  Detailed Aging By Principal
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/reports-overview/rsmtypereport" target="reports-overview/rsmtypereport">
                  RSM Report
                </a>
              </li>
            </ul>
          </div>
        </li> -->

      </ul>
    </nav>

    <generate-all-report-modal
      :show="showGenerateAllReport"
      @on-close="onClose"
    />
  </div>
</template>

<script>
import generateAllReportModal from "@/views/reports/components/generateAllReport.vue";

export default {
  components: {
    generateAllReportModal,
  },
  data() {
    return {
      showGenerateAllReport: false,
    };
  },
  methods: {
    notImplemented: function () {
      this.$toast.open({
        message: "This feature is not yet implemented.",
        type: "info",
      });
    },
    onClose: function () {
      this.showGenerateAllReport = false;
    },
    redirectToReportsOverview: function () {
      var url = "http://ors-report.oxford.ph";
      var token = this.$store.getters.token;
      // var sessionToken = sessionStorage.getItem('ors-token');
      var httpRequest = `${url}?token=${token}`
      window.location.replace(httpRequest);
    }
  },
};
</script>

<style>
</style>